import { FORM_VALUE_ENUM, FORM_VALUE_INTER } from './constant';

export const convert = (payload: FORM_VALUE_INTER) => ({
  ...payload,
  userType: payload[FORM_VALUE_ENUM.USER_TYPE]?.value,
  user: payload[FORM_VALUE_ENUM.USER]
    ? payload[FORM_VALUE_ENUM.USER].map((e) => e.value)
    : [],
});
